import { ShieldCheck, Bot, Scale, RefreshCw, Fingerprint, Gauge } from "lucide-react";

const TRUST = "https://images.unsplash.com/photo-1638947604157-d259d219eeee";

const pillars = [
  { icon: RefreshCw, title: "Visible review lifecycle", desc: "Every review shows its state, from Under Review to Published, or Declined with a clear reason. No black boxes." },
  { icon: Fingerprint, title: "Verified Employee badges", desc: "Optional private work-email verification proves employment without ever exposing your identity." },
  { icon: Bot, title: "AI + human moderation", desc: "Gemini-powered spam & sentiment-abuse screening backs a human moderation queue with a full audit trail." },
  { icon: Scale, title: "Fair dispute workflow", desc: "Employers can flag reviews through a structured takedown and legal-request process, surfaced, not buried." },
  { icon: Gauge, title: "Anti-abuse layer", desc: "Duplicate detection, rate limiting and review-bombing checks keep the data honest." },
  { icon: ShieldCheck, title: "Full anonymity", desc: "Reviews are never tied to your public identity. Verification signals stay private." },
];

export default function Trust() {
  return (
    <main className="mx-auto max-w-6xl px-5 py-14 lg:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div className="animate-fade-up">
          <p className="eyebrow mb-3">Trust & Safety</p>
          <h1 className="text-4xl font-bold leading-tight sm:text-5xl">Data you can actually <span className="text-teal-400">trust.</span></h1>
          <p className="mt-5 text-slate-300">iGamingTruth is engineered credibility-first. Here's exactly how we keep reviews honest, anonymous and fair to everyone.</p>
        </div>
        <div className="relative animate-fade-up" style={{ animationDelay: "100ms" }}>
          <img src={TRUST} alt="Abstract security shield representing verification" className="relative w-full rounded-3xl border border-[#DDDAD1] object-cover" />
        </div>
      </div>

      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {pillars.map((p, i) => (
          <div key={p.title} className="card-surface lift p-6 animate-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-teal-500/15 text-teal-400"><p.icon className="h-6 w-6" aria-hidden="true" /></span>
            <h3 className="mt-5 text-lg font-semibold">{p.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{p.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 card-surface p-8">
        <h2 className="text-2xl font-bold">Legal & takedown requests</h2>
        <p className="mt-3 max-w-3xl text-slate-400">If you're an employer and believe a review is defamatory or factually inaccurate, use the <span className="text-slate-200">Dispute</span> button on any review. Your request enters our moderation queue with a documented audit trail and is assessed against our content policy. We respond to legitimate legal requests promptly and transparently.</p>
      </div>
    </main>
  );
}
